import React from 'react'
import { isMobile } from 'react-device-detect'

// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'

// import { FacebookLogin } from 'react-facebook-login-component';


import {
  DefaultCardContainer,
  CustomGoogleLoginButton,
  CustomFaceBookLoginButton,
  ButtonLoginIcon,
  FacebookLoginButton
} from '../style/LoginScreenStyle'

import GenericInput from '../../../GenericComponents/GenericInput'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GoogleIcon from '../../../assets/REDESIGN_Assets/LoginScreen/google-icon.svg'
import FacebookIcon from '../../../assets/REDESIGN_Assets/LoginScreen/facebook-icon.svg'

const LoginCardLoginEmailMode = ({
  setUserRegisterModeOn,
  responseFacebook,
  responseGoogle,
  isUserLoginModeOn,
  handleChangeToRemindPasswordMode,
  handleGatherLoginInputData,
  handleLoginUser,
  onKeyUp,
}) => {
  const onEmailFocus = () => {
    document.querySelector('.login-mode-card').classList.add('mobile-login')
  }

  const onEmailBlur = () => {
    document.querySelector('.login-mode-card').classList.remove('mobile-login')
  }

  return (
    <DefaultCardContainer className="card-container" onKeyPress={onKeyUp}>
      <GenericInput
        onChange={(e) => handleGatherLoginInputData(e.target.value, 'email')}
        type="email"
        placeholder="Email"
        onFocus={onEmailFocus}
        onBlur={onEmailBlur}
      ></GenericInput>
      <GenericInput
        onChange={(e) => handleGatherLoginInputData(e.target.value, 'password')}
        type="password"
        placeholder="Hasło"
      ></GenericInput>
      <GenericButton
        onKeyDown={(e) => handleLoginUser(e)}
        onClick={(e) => handleLoginUser(e)}
        tAlign="center"
        className="standard"
        justify={'center'}
      >
        Zaloguj się
      </GenericButton>
      <GenericTextSpan tAlign="center" margin={'5% 0 0 0'}>
        Zapomniałaś hasła?
        <span
          className="register-link"
          onClick={handleChangeToRemindPasswordMode}
        >
          Możesz odzyskać
        </span>
      </GenericTextSpan>
      <GenericTextSpan tAlign="center" margin={'2% 0 3% 0'}>
        lub
      </GenericTextSpan>

      <CustomGoogleLoginButton
        clientId="7011897535-sm0r4hcb9t68rp3b7rivu5u2iqshjbc3.apps.googleusercontent.com"
        buttonText="Zaloguj przez Google"
        onSuccess={responseGoogle}
        // onFailure={(e) => responseGoogle(e)}
        render={(renderProps) => (
          <GenericRow
            className={'google-button pointer'}
            onClick={renderProps.onClick}
            justify={'flex-start'}
          >
            <GenericIcon
              className="margin-right-auto"
              margin={'0 5% 0 0'}
              src={GoogleIcon}
              width={isMobile ? '4.5vw' : '1.2vw'}
              height={isMobile ? '4.5vw' : '1.2vw'}
            ></GenericIcon>
            <GenericTextSpan display={'block'} width={'100%'}>
              Zaloguj się przez Google{' '}
            </GenericTextSpan>
          </GenericRow>
        )}
        cookiePolicy="single_host_origin"
        responseType="code,token"
        className="google-button"
      />

<FacebookLoginButton socialId="732721697519360"
                       language="en_US"
                       scope="public_profile,email"
                       responseHandler={responseFacebook}
                       xfbml={true}
                       fields="email,name"
                       version="v2.5"
                       className="facebook-login"
                      //  buttonText="Login With Facebook"

                       >
<GenericRow
            margin={'3% 0 0 0'}
            className={'facebook-button pointer'}
            // onClick={renderProps.onClick}
            justify={'flex-start'}
          >
            <GenericIcon
              className="margin-right-auto"
              margin={'0 5% 0 0'}
              src={FacebookIcon}
              width={isMobile ? '4.5vw' : '1.2vw'}
              height={isMobile ? '4.5vw' : '1.2vw'}
            ></GenericIcon>
            <GenericTextSpan display={'block'} width={'100%'}>
              Zaloguj się przez Facebook{' '}
            </GenericTextSpan>
          </GenericRow>

                       </FacebookLoginButton>

      {/* <FacebookLogin
        appId="732721697519360"
        autoLoad={false}
        callback={responseFacebook}
        // callback={(resp)=>this.responseFacebook(resp)}
        fields="name,email"
        disableMobileRedirect={true}
        render={(renderProps) => (
          <GenericRow
            margin={'3% 0 0 0'}
            className={'facebook-button pointer'}
            onClick={renderProps.onClick}
            justify={'flex-start'}
          >
            <GenericIcon
              className="margin-right-auto"
              margin={'0 5% 0 0'}
              src={FacebookIcon}
              width={isMobile ? '4.5vw' : '1.2vw'}
              height={isMobile ? '4.5vw' : '1.2vw'}
            ></GenericIcon>
            <GenericTextSpan display={'block'} width={'100%'}>
              Zaloguj się przez Facebook{' '}
            </GenericTextSpan>
          </GenericRow>
        )}
      /> */}

      <GenericTextSpan margin={'10% 0 0 0'}>
        Nie masz konta?{' '}
        <span className="register-link" onClick={() => setUserRegisterModeOn()}>
          Zarejestruj się{' '}
        </span>
      </GenericTextSpan>
    </DefaultCardContainer>
  )
}

export default LoginCardLoginEmailMode
